import { ServiceMaker, methods, services } from "../services";

export const createPrivacySetting = (payload) =>
  ServiceMaker(
    `/cms/privacy-setting/create`,
    methods.POST,
    services.master,
    payload
  );

export const listPrivacySetting = (id) =>
  ServiceMaker(
    `cms/privacy-setting/list?tenant=${id}`,
    methods.GET,
    services.master
  );

  export const editPrivacySetting = (payload) =>
    ServiceMaker(
      `/cms/privacy-setting/update/${payload.id}`,
      methods.PUT,
      services.master,
      payload.data
    );
  
export const deletePrivacySetting = (payload) =>
  ServiceMaker(
    `/cms/privacy-setting/delete/${payload}`,
    methods.DELETE,
    services.master,
    payload.data
  );
  export const viewPrivacySetting = (payload, content, slug) =>
    ServiceMaker(
      `/cms/privacy-setting/view?tenant=${payload}&content=${content}&scope=${slug}`,
      methods.GET,
      services.master
    );
